module.exports = __webpack_public_path__ + "img/8.b27e1c76.jpg";